/**
 * Get content group for order or products (Mobile/Business/Consumer)
 * @param {string[]} categoriesArray
 * @returns {string}
 */
export default (categoriesArray) => {
	if (categoriesArray.includes('Mobile')) {
		return 'Mobile';
	} else if (categoriesArray.includes('Business')) {
		return 'Business';
	} else {
		return 'Consumer';
	}
};
